import * as React from 'react';
import './eventArchivePage.module.scss';
import { observer } from 'mobx-react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { observable, makeObservable } from 'mobx';
import { RemoteEventListState } from '../../components/organisms/events/states/RemoteEventListState';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { EventListPane } from '../../components/molecules/events/EventListPane';
import { OverlayPage } from '../../../commonv3/components/molecules/layout/OverlayPage';
import { V2Routes } from '../../../mainv2/routes';
import { V3Routes } from '../../routes';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { routingStore } from '../../../common/stores/routing';
import { parseQueryParams } from '../../types/location';
import { EventPane } from '../../components/organisms/events/EventPane';
import { RouteComponentProps } from 'react-router';
import { FlagKeys } from '../../../mainv2/states/CurrentUserState';

type Props = RouteComponentProps;

export const EventArchivePage = withNavigation(NavigationSpecs.home('white', false))(
  observer(
    class EventArchivePage extends React.Component<Props> {
      eventList = RemoteEventListState.getInstance();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          eventList: observable,
        });
      }

      componentDidMount(): void {
        this.eventList.init();
      }

      render() {
        const { event_id } = parseQueryParams(this.props.location);
        const eventId = Array.isArray(event_id) ? event_id[0] : event_id;
        return (
          <Page styleName="page">
            <PageHeader title="EVENT ARCHIVES" subTitle="過去のイベント" showOnMobile={true} />
            <PageBody styleName="body">
              {this.eventList.eventArchives.loading && <LoaderRow />}
              <EventListPane
                events={this.eventList.eventArchives.getOrElse([])}
                onItemClick={(ev) =>
                  GlobalStatesV3.routing.push(
                    GlobalStatesV3.currentUser.hasEnabledFlagKey(FlagKeys.REDIRECT_EVENT_DETAIL_PAGE)
                      ? V2Routes.eventDetailsPage(ev.id)
                      : V3Routes.DynamicPath.openEventOverlay(routingStore.location, ev.id)
                  )
                }
              />
              <OverlayPage
                open={!!eventId}
                onRequestClose={() => routingStore.push(V3Routes.eventArchives())}
                id={'events'}
              >
                {eventId && <EventPane eventId={eventId} />}
              </OverlayPage>
            </PageBody>
          </Page>
        );
      }
    }
  )
);
